<!-- src/views/outpatient/components/FollowForm.vue -->
<template>
  <el-dialog
      title="新增随访"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      class="form-dialog"
      @close="handleClose"
      :before-close="handleClose">
    <el-form :model="formData" :rules="formRules" ref="followForm" label-width="100px" size="small" label-position="left">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="随访类型:" prop="type">
            <el-select v-model="formData.type" placeholder="请选择随访类型" style="width: 100%">
              <el-option label="复诊提醒" :value="1"></el-option>
              <el-option label="疗程提醒" :value="2"></el-option>
              <el-option label="慢病随访" :value="3"></el-option>
              <el-option label="用药提醒" :value="4"></el-option>
              <el-option label="其他" :value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="执行人:" prop="exeId">
            <el-select v-model="formData.exeId" placeholder="请选择执行人" filterable style="width: 100%">
              <el-option
                  v-for="item in doctorOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="执行次数:" prop="num">
            <el-input-number v-model="formData.num" :min="1" :max="999" controls-position="right" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="间隔天数:" prop="intervalDay">
            <el-input-number v-model="formData.intervalDay" :min="0" :max="365" controls-position="right" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开始时间:" prop="startTime">
            <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                placeholder="请选择开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="说明:" prop="describ">
            <el-input type="textarea" v-model="formData.describ" placeholder="请输入说明" :rows="3"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      <el-button size="mini" @click="handleClose">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {followAdd} from "@/api/FollowUpClinic/FollowUpClinic";

export default {
  name: "FollowForm",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 可选：预填数据
    defaultData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      formData: {
        patientId: null,
        seeId: null,
        type: null,
        exeId: null,
        num: 1,
        intervalDay: 0,
        startTime: '',
        describ: ''
      },
      formRules: {
        patientId: [{ required: true, message: '请输入患者ID', trigger: 'blur' }],
        seeId: [{ required: true, message: '请输入就诊ID', trigger: 'blur' }],
        type: [{ required: true, message: '请选择随访类型', trigger: 'change' }],
        exeId: [{ required: true, message: '请选择执行人', trigger: 'change' }],
        num: [{ required: true, message: '请输入执行次数', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }]
      }
    };
  },
  computed: {
    doctorOptions() {
      return this.$store.getters['preload/getDoctorListOptions'] || [];
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val && this.defaultData) {
          // 预填数据
          this.formData = {
            patientId: this.defaultData.patientId || null,
            seeId: this.defaultData.seeId || null,
            type: this.defaultData.type || null,
            exeId: this.defaultData.exeId || null,
            num: this.defaultData.num || 1,
            intervalDay: this.defaultData.intervalDay || 0,
            startTime: this.defaultData.startTime || '',
            describ: this.defaultData.describ || ''
          };
        }
      },
      immediate: true
    }
  },
  methods: {
    // 提交表单
    async submitForm() {
      try {
        await this.$refs.followForm.validate();
      } catch (error) {
        this.$message.warning('请填写完整信息');
        return;
      }

      this.submitLoading = true;
      try {
        const res = await followAdd(this.formData);
        if (res.code === 200 || res.code === 0) {
          this.$message.success('新增成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(res.message || '新增失败');
        }
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error('网络错误，请稍后重试');
      } finally {
        this.submitLoading = false;
      }
    },

    // 关闭弹窗，重置表单
    handleClose() {
      this.dialogVisible = false;
      // 重置表单数据
      this.formData = {
        patientId: null,
        seeId: null,
        type: null,
        exeId: null,
        num: 1,
        intervalDay: 0,
        startTime: '',
        describ: ''
      };
      // 清除校验
      this.$nextTick(() => {
        if (this.$refs.followForm) {
          this.$refs.followForm.clearValidate();
        }
      });
      // 通知父组件关闭
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="less" scoped>
.form-dialog /deep/ .el-form-item {
  margin-bottom: 12px;
}
.form-dialog /deep/ .el-form-item__label {
  font-size: 12px;
}
.form-dialog /deep/ .el-form-item__content {
  font-size: 12px;
}
/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}
/deep/ .el-dialog__headerbtn {
  top: 12px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
/deep/ .el-dialog__header {
  background-color: #39648f;
  padding: 8px;
}
/deep/ .el-dialog__body {
  border: 1px solid #efefef;
  padding: 8px;
}
</style>